/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useContext, useRef } from 'react';
import { WebSocket } from '../utils/WebSocket';
import { useInterval } from '../hooks/useInterval';

const SECOND = 1000;
const MINUTE = SECOND * 60;

export const WebsocketContext = React.createContext();

export function WebsocketProvider({ children }) {
  const websocket = useRef();
  const [isReady, setReady] = useState(false);
  const [message, setMessage] = useState();
  useEffect(() => {
    manageConnection();
    return () => {
      if (websocket.current) websocket.current.close();
    };
  }, []);

  useInterval(() => {
    if (isReady) {
      websocket.current.send(
        JSON.stringify({
          event: 'ping',
        })
      );
    }
  }, MINUTE * 5);

  function manageConnection() {
    const client = WebSocket();
    client.onerror = err => {
      console.error('Connection Error', err);
    };
    client.onopen = () => {
      const date = new Date();
      console.log(`WebSocket Client Connected at ${date.toString()}`);
      setReady(true);
    };
    client.onmessage = e => setMessage(JSON.parse(e.data));
    client.onclose = e => {
      setReady(false);
      const date = new Date();
      console.log(`Closing connection at ${date.toString()}`, e);
      console.log('trying to reopen connection');
      manageConnection();
    };
    websocket.current = client;
  }

  return (
    <WebsocketContext.Provider
      value={{
        websocket: websocket.current,
        isReady,
        message,
      }}
    >
      {children}
    </WebsocketContext.Provider>
  );
}

export const useWebsocket = () => useContext(WebsocketContext);
